/* eslint-disable @typescript-eslint/restrict-template-expressions */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable max-len */
import React from "react";
import { connect } from "react-redux";
import { DispatchFunc } from "../../../../store/ActionTypes";
import { ReduxState, isRemoteLoading } from "../../../../store/ReduxState";
import { remoteClearError, remoteClearResponse, remoteTrigger } from "../../../../store/RemoteActions";
import { RemoteScope } from "../../../../store/RemoteTypes";
import { Mary } from "@vwpfs/vwpfs-mary-react-comp-lib";
import { InitType } from "../../../../store/Init/Types";
import { Form } from "./AdditionalTax/Form";
import { ThemePalette, ThemePaletteState } from "@vwpfs/vwpfs-mary-react-comp-lib/dist/theme";
import { Link, LinkTarget } from "@vwpfs/vwpfs-mary-react-comp-lib/dist/components/core/05-atoms/Link";
import { Hr } from "@vwpfs/vwpfs-mary-react-comp-lib/dist/components/core/05-atoms";
import { RTE } from "@vwpfs/vwpfs-mary-react-comp-lib/dist/components/core/07-organisms";
import { getCurrentEnv } from "@vwpfs/vwpfs-mary-react-comp-lib/dist/utils";
import { FormAdditionalTaxObject, FormAdditionalTaxObjectResponse } from "../../../../store/AdditionalTax/Types";

interface OwnProps {
    asPage: boolean;
    routeProps?: string;
}

interface StateProps {
    init: InitType;
    loading: boolean;
    resultAdditionalTax?: FormAdditionalTaxObjectResponse;
    submitLoadingAdditionalTax: boolean;
}

/**
 *
 */
interface DispatchProps {
    triggerInit: (route: string, channel: string) => void;
    onChangeAdditionalTaxFormFields: (body: FormAdditionalTaxObject, channel: string) => void;
    clearResult: () => void;
}

type Props = StateProps & DispatchProps & OwnProps;

/**
 *
 * @param s
 */
const mapStateToProps = (s: ReduxState): StateProps => ({
    init: s.prop("remote").prop(RemoteScope.INIT) as InitType,
    loading: isRemoteLoading(s, RemoteScope.INIT),
    resultAdditionalTax: s.prop("remote").prop(RemoteScope.ADDITIONAL_TAX_POST),
    submitLoadingAdditionalTax: isRemoteLoading(s, RemoteScope.ADDITIONAL_TAX_POST),
});


/**
 *
 */
const mapDispatchToProps = (dispatch: DispatchFunc): DispatchProps => ({
    triggerInit: (route: string, channel: string) => dispatch(remoteTrigger(RemoteScope.INIT, {route, channel})),
    onChangeAdditionalTaxFormFields: (body, channel: string) =>
        dispatch(remoteTrigger(RemoteScope.ADDITIONAL_TAX_POST, {form: body, channel})),
    clearResult: () => {
        dispatch(remoteClearError(RemoteScope.ADDITIONAL_TAX_POST));
        dispatch(remoteClearResponse(RemoteScope.ADDITIONAL_TAX_POST));
    },
});

class AdditionalTaxInitComp
    extends React.Component<Props, {}> {

    private formInputValues: FormAdditionalTaxObject | undefined = undefined;

    public constructor(props: Props) {
        super(props);
        this.sendAmountOnChange = this.sendAmountOnChange.bind(this);
        this.handleFormInputChange = this.handleFormInputChange.bind(this);
    }

    public componentDidMount(): void {
        const url = new URL(window.location.href);
        const channel = url.searchParams.get("channel");
        const hasCalcType = this.props.routeProps === "additional-tax";
        if(this.props.init === undefined && channel !== null && hasCalcType) {
            this.props.triggerInit(this.props.routeProps ?? "", channel ?? "");
        }
    }

    public componentDidUpdate(prevProps: Props) {
        if(prevProps.resultAdditionalTax !== this.props.resultAdditionalTax) {
            this.sendAmountOnChange();
        }
    }

    public render() {
        const url = new URL(window.location.href);
        const hasErrorOf = !url.searchParams.get("channel") ? "channel" : this.props.routeProps === "additional-tax" ? undefined : "calcType";
        return (
            <Mary.base.BaseConsumer>
                { ({getTheme}) => (
                    <Mary.base.Container
                        theme={{
                            shadow: this.props.asPage ? Mary.theme.ThemeShadowSizes.SMALL : undefined,
                            palette: this.props.asPage ? Mary.theme.ThemePalette.CONTRAST_PRIMARY : undefined,
                            padding: {
                                "": { y: 3 },
                                "sm": { y: 4 },
                            },
                        }}
                    >
                        {!hasErrorOf ? (
                            <div style={{ minHeight: "300px", position: "relative" }}>
                                {this.props.init && !this.props.loading && (
                                    <>
                                        {getTheme() !== Mary.theme.Themes.MOBILIST && (
                                            <>
                                                <div style={{ marginBottom: "15px" }}>
                                                    <Mary.atoms.Heading
                                                        level={Mary.atoms.Headings.H1}
                                                        headingStyle={Mary.atoms.Headings.H3}
                                                    >
                                                        {this.props.init?.title ?? ""}
                                                    </Mary.atoms.Heading>
                                                </div>
                                                <div style={{ marginBottom: "10px" }}>
                                                    <Mary.organisms.RTE content={this.props.init?.description ?? ""} />
                                                </div>
                                            </>
                                        )}
                                        {this.props.resultAdditionalTax?.warning &&
                                        <Mary.atoms.Blockquote
                                            theme={{
                                                palette: Mary.theme.ThemePalette.CONTRAST_TERTIARY,
                                                margin: {
                                                    "": { b: 2 },
                                                    "sm": { b: 2 },
                                                },
                                            }}
                                            background
                                            style={{ position: "relative" }}
                                        >
                                            <div style={{display: "flex",
                                                flexDirection: "column",
                                                alignItems: "flex-start",
                                                gap: "3px"}}>

                                                <Mary.base.Div theme={{palette: ThemePalette.CONTRAST_TERTIARY}}
                                                    className="scl-h-foreground--brand-text-body"
                                                    style={{
                                                        textTransform: "none",
                                                        borderRadius: 0,
                                                        hyphens: "auto",
                                                        padding: "2px",
                                                        paddingLeft: "8px",
                                                        paddingRight: "8px"}}>
                                                    <b>{this.props.resultAdditionalTax?.warning}</b>
                                                </Mary.base.Div>
                                            </div>
                                        </Mary.atoms.Blockquote>}
                                        <Form
                                            init={this.props.init}
                                            onChangeCallAPI={this.props.onChangeAdditionalTaxFormFields}
                                            result={this.props.resultAdditionalTax}
                                            submitLoading={this.props.submitLoadingAdditionalTax}
                                            onFormDataChange={this.handleFormInputChange}
                                            clearResult={this.props.clearResult}
                                        />
                                    </>
                                )}
                                {this.props.loading && (
                                    <Mary.atoms.loadingindicator.LoadingIndicator
                                        type={Mary.atoms.loadingindicator.LoadingIndications.DEFAULT}
                                        theme={{ palette: Mary.theme.ThemePalette.BRAND_PRIMARY }}
                                    />
                                )}
                            </div>
                        ) : (
                            <>
                                <Mary.atoms.Blockquote theme={{ paletteState: ThemePaletteState.WARNING }}>
                                    <h4>{hasErrorOf === "channel" ? "Kanaal ontbreekt" : "Onbekend formulier opgevraagd"}</h4>
                                    <br />
                                    <div className="scl-h-text">
                                        {hasErrorOf === "channel" ? "U heeft geen kanaal opgegeven." : "Het formulier dat u probeert op te vragen is niet bekend."}
                                    </div>
                                </Mary.atoms.Blockquote>
                                {getCurrentEnv() === "local" && (
                                    <>
                                        <Hr />
                                        <RTE>
                                            <p>Problemen met het formulier? Bezoek de <Link link={{target: LinkTarget.BLANK, href: `${window.location.origin}/setup`}} theme={{palette: ThemePalette.BRAND_ACCENT}} ><b>Setup wizard</b></Link> van Team Claude voor de juiste configuratie.</p>
                                        </RTE>
                                    </>)}
                            </>
                        )}
                    </Mary.base.Container>
                )}
            </Mary.base.BaseConsumer>
        );
    }

    private handleFormInputChange = (formData: FormAdditionalTaxObject) => {
        this.formInputValues = formData;
    };

    private sendAmountOnChange() {
        const calcType = this.props.routeProps;
        const amount = this.props.resultAdditionalTax?.totalAmountValue;
        window.parent.postMessage(
            {
                type: `claude:scalc:${calcType ?? ""}:amount`,
                data: {
                    amount: amount,
                    inputs: this.formInputValues ?? {},
                },
            },
            "*",
        );
    }
}

export const AdditionalTaxInit = connect(
    mapStateToProps,
    mapDispatchToProps,
)(AdditionalTaxInitComp);
